export type WithSpeedFactor = { speed_factor?: number } & Record<string, unknown>;

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const speedFactorToPercent = (value: number): number => Math.round(Number((value - 1).toFixed(2)) * 100);
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const percentToSpeedFactor = (value: number): number => 1 + Number((value / 100).toFixed(2));

export const toDisplaySpeedFactor = <T extends WithSpeedFactor>(entity: T): T =>
	Number.isFinite(entity.speed_factor)
		? ({ ...entity, speed_factor: speedFactorToPercent(entity.speed_factor) } as T)
		: entity;

export const toStorageSpeedFactor = <T extends WithSpeedFactor>(entity: T): T =>
	Number.isFinite(entity.speed_factor)
		? ({ ...entity, speed_factor: percentToSpeedFactor(entity.speed_factor) } as T)
		: entity;
